// @flow

import React from 'react';
import type { Node } from 'react';
import { Avatar } from '@riseart/common';
import { FormattedMessage } from 'react-intl';

import { enquireFormSectionCls } from 'shared_components/forms/enquire/Form.less';

type Props = {
  name: string,
  avatar?: string,
};

/**
 * AdvisorSection
 *
 * @param {Props} props
 */
export const AdvisorSection = ({ name, avatar }: Props): Node => (
  <div className={enquireFormSectionCls}>
    <Avatar align="left" theme="black" image={avatar} name={name}>
      <FormattedMessage
        id="forms.emailEnquire.advisorInfo"
        values={{ advisorName: name.toUpperCase(), strong: (chunks) => <strong>{chunks}</strong> }}
      >
        {(info: string) => <span>{info}</span>}
      </FormattedMessage>
    </Avatar>
  </div>
);
